import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import '../../styles/Modal.css';

const Modal = ({ show, onClose, title, children }) => {
  const titleId = useId();
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!show || typeof document === 'undefined') return undefined;
    const previouslyFocused = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
      previouslyFocused?.focus?.();
    };
  }, [onClose, show]);

  if (!show || typeof document === 'undefined') {
    return null;
  }

  const modalMarkup = (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <h5 className="modal-title" id={titleId}>{title}</h5>
          <button
            ref={closeButtonRef}
            type="button"
            onClick={onClose}
            className="modal-close-btn"
            aria-label="Close dialog"
          >
            &times;
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalMarkup, document.body);
};

export default Modal;
